const LINE_6_SUBTYPE_CODES = new Set(['EC9', 'EC10', 'EC11']);
const NON_LINE_6_SUBTYPE_CODES = new Set([
  'EC1',
  'EC2',
  'EC3',
  'EC4',
  'EC5',
  'EC6',
  'EC7',
  'EC8'
]);

/** Endorsements V10: line 6 → EC9–EC11; all other lines → EC1–EC8. */
export function filterAmendmentSubTypesByLineCode<T extends { code: string }>(
  items: T[],
  lineCode: string
): T[] {
  const allowedCodes =
    lineCode === '6' ? LINE_6_SUBTYPE_CODES : NON_LINE_6_SUBTYPE_CODES;

  return items.filter((item) => allowedCodes.has(item.code));
}
